module.exports = __webpack_public_path__ + "static/media/berezovska-home.e41bf570.jpg";